import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import classNames from 'classnames';

import randomstring from 'uuid/v4';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

import BarChart from '@material-ui/icons/BarChart';
import BubbleChart from '@material-ui/icons/BubbleChart';
import History from '@material-ui/icons/List';
import Info from '@material-ui/icons/Info';


function isOk(field) {
    return field === undefined;
}

function helperText(field, intl) {
    return field === undefined || field.length === 0 ? intl.formatMessage({ id: 'required' }) : '';
}

class DialogWidget extends React.Component {

    state = {
        nombre: this.props.widget ? this.props.widget.nombre : '',
        tipo: this.props.widget ? this.props.widget.tipo : undefined,
        origen: this.props.widget ? this.props.widget.origen : undefined,
        metadatos: this.props.widget ? this.props.widget.metadatos : {},
        tiempo: this.props.widget && this.props.widget.metadatos ? this.props.widget.metadatos.periodo : undefined
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleClose = (nombre, origen, tipo, metadatos) => (event) => {
        if (metadatos) {
            metadatos = {};
            metadatos.periodo = this.state.tiempo;
        }
        this.props.onClose(nombre, origen, tipo, metadatos);
    };

    handleType = (type, disable) => (event) => {
        if (!disable) {
            this.setState({ tipo: type })
        }
    }

    isCorrect = () => {
        const { nombre, origen, tipo } = this.state;
        return nombre
            && nombre.length > 0
            && origen
            && tipo;
    };


    render() {
        const { nombre, origen, tipo, metadatos, tiempo } = this.state;
        const { intl } = this.props;

        const aux = this.props.indicators && origen
            ? this.props.indicators.filter(f => {
                if (f.id.toString() === origen) {
                    return f;
                } else {
                    return null;
                }
            })
            : undefined;

        const indicator = aux && aux.length === 1 ? aux[0] : undefined;

        const IconButton = ({ icon, text, type, current, disable = false }) => (
            <Grid item xs={12} sm={4}>
                <div
                    onClick={this.handleType(type, disable || this.props.see)}
                    className={classNames(
                        'hand margin_left_6 margin_right_6 margin_bottom_12 flex_full_column box elements_center align_center padding_borders barlow_regular_small',
                        current === type
                            ? 'bg_bluish c_white'
                            : disable
                                ? 'bg_disabled c_white'
                                : 'c_bluish bg_white',
                    )}
                >
                    {icon}
                    <FormattedMessage id={text} />
                </div>
            </Grid>
        );

        return (
            <Dialog
                open={true}
                onClose={this.handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Widget"}
                </DialogTitle>
                <DialogContent style={{ minWidth: 320 }} className={''}>
                    <TextField
                        autoFocus
                        fullWidth
                        id={'nombre'}
                        name={'nombre'}
                        required
                        error={isOk(nombre)}
                        helperText={helperText(nombre, intl)}
                        label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                        className={'flex_full_row'}
                        value={nombre}
                        onChange={this.handleChange}
                        margin="normal"
                    />
                    <div className="margin_top_24" >
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'widget_title_origen' })}
                            </InputLabel>
                            <Select
                                native
                                value={origen}
                                fullWidth
                                onChange={this.handleChange}
                                inputProps={{ name: 'origen', id: 'local-origen' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {this.props.indicators &&
                                    this.props.indicators.map((cat) => {
                                        return (
                                            <option key={randomstring()} value={cat.id}>
                                                {cat.nombre}
                                            </option>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                    </div>
                    {indicator &&
                        <div
                            key={randomstring()}
                            className="flex_full_column margin_top_24">
                            <div className="barlow_regular_smalltext c_disabled margin_bottom_5">
                                <FormattedMessage id="form_field_description" />
                            </div>
                            <div
                                className=" flex_full_row center" >
                                <Info className="c_cornflower_blue margin_right_6" />
                                <span className="flex_auto_row wrap barlow_italic_medium c_cornflower_blue">
                                    {indicator.descripcion}
                                </span>
                            </div>
                        </div>
                    }
                    <Grid container className="margin_top_24 elements_center">
                        <IconButton
                            icon={<BubbleChart className="hand" />}
                            text={'widget_type_chart_bubble'}
                            type={1}
                            current={tipo}
                            disable={!indicator || indicator.tipos.indexOf(1) < 0}
                        />
                        <IconButton
                            icon={<BarChart className="hand" />}
                            text={'widget_type_chart_bar'}
                            type={2}
                            current={tipo}
                            disable={!indicator || indicator.tipos.indexOf(2) < 0}
                        />
                        <IconButton
                            icon={<History className="hand" />}
                            text={'widget_type_chart_historic'}
                            type={3}
                            current={tipo}
                            disable={!indicator || indicator.tipos.indexOf(3) < 0}
                        />
                    </Grid>
                    <div className="margin_top_24" >
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'widget_title_time' })}
                            </InputLabel>
                            <Select
                                native
                                value={tiempo}
                                fullWidth
                                onChange={this.handleChange}
                                inputProps={{ name: 'tiempo', id: 'tiempo-origen' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                <option key={randomstring()} value={'today'}>
                                    {intl.formatMessage({ id: 'widget_today' })}
                                </option>
                                <option key={randomstring()} value={'yesterday'}>
                                    {intl.formatMessage({ id: 'widget_yesterday' })}
                                </option>
                                <option key={randomstring()} value={'lastweek'}>
                                    {intl.formatMessage({ id: 'widget_lastweek' })}
                                </option>
                                <option key={randomstring()} value={'wtd'}>
                                    {intl.formatMessage({ id: 'widget_wtd' })}
                                </option>
                                <option key={randomstring()} value={'wtd1'}>
                                    {intl.formatMessage({ id: 'widget_wtd1' })}
                                </option>
                                <option key={randomstring()} value={'mtd'}>
                                    {intl.formatMessage({ id: 'widget_mtd' })}
                                </option>
                                <option key={randomstring()} value={'mtd1'}>
                                    {intl.formatMessage({ id: 'widget_mtd1' })}
                                </option>
                                <option key={randomstring()} value={'ytd'}>
                                    {intl.formatMessage({ id: 'widget_ytd' })}
                                </option>
                                <option key={randomstring()} value={'ytd1'}>
                                    {intl.formatMessage({ id: 'widget_ytd1' })}
                                </option>
                            </Select>
                        </FormControl>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose()} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button
                        onClick={this.handleClose(nombre, origen, tipo, metadatos)}
                        color="primary"
                        autoFocus
                        disabled={!this.isCorrect()}
                    >
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

DialogWidget.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(DialogWidget);


// WEBPACK FOOTER //
// ./src/components/complex/dashboard/DialogWidget.js